/* eslint-disable react-hooks/rules-of-hooks */
import { Alert, Box, Modal, Snackbar, SnackbarOrigin, Tab, Tabs, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { SelectChangeEvent } from "@mui/material/Select";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RoutesWeb } from "src/shared/interfaces/routes";
import ButtonCircle from "../../../../../shared/components/button_circle";
import { WrapMain } from "../../../../../shared/modules/wrap_main";
import {
    gerenciaTecnicaSlice,
    selectGtoState,
    useDispatch,
} from "../../../../../stateManagement/redux";
import { getDailyReport } from "../../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { LocationWithoutProduction, SummaryActivities } from "../../../../utils/getSummary";
import { PlannedActivitiesComponent } from "./plannedActivities";
import { RequirementComponent } from "./requerimientos";
import { SummaryComponent } from "./resumen";
import { GraficasComponent } from './graficas'
import "./styles.scss";
import { UpdateTaskModal } from "./updateTaskModal";
import { FilesViewer } from "./filesViewer";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{}}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const index = () => {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const mainState = useSelector(selectGtoState);

    const [infoAlert, setInfoAlert] = useState({
        open: false,
        message: "",
    })

    const [messageSummary, setMessageSummary] = useState<SummaryActivities>();

    const [locationWithoutProduction, setlocationWithoutProduction] = useState<LocationWithoutProduction[]>()

    const [plannedActivities, setPlannedActivities] = useState([]);

    const [filesForDataRange, setFilesForDataRange] = useState([]);

    const [requirementFilter, setRequirementFilter] = useState("all");

    const [activesSquadData, setActivesSquadData] = useState<any>({})

    const [openModal, setOpenModal] = useState(false)

    const handleChangeRequirementFilter = (
        event: SelectChangeEvent | string
    ) => {
        const newValue =
            typeof event === "string"
                ? event
                : (event as SelectChangeEvent).target.value;

        setRequirementFilter(newValue);
    };

    const handleGoToDashboard = () => {
        dispatch(gerenciaTecnicaSlice.actions.emptyReportData());
        navigate('/gto/dashboard');
    };

    useMemo(() => {
        const response: any = mainState.reportWithData;
        setlocationWithoutProduction(response?.locationsWithoutProduction);
        setMessageSummary(response?.membersList);
        setPlannedActivities(response?.plannedActivities);
        setFilesForDataRange(response?.filesForDateRange);
    }, [mainState.reportWithData]);

    useEffect(() => {
        getDailyCloseData();
    }, [mainState.reportFilters]);


    const getDailyCloseData = () => {
        const filters = mainState.reportFilters;
        const report = mainState?.reportFilters?.activeReport;

        if (report && filters) {
            dispatch(
                getDailyReport(
                    report.id,
                    report.code,
                    filters.startDate || "",
                    filters.endDate || "",
                    filters.projectId || ""
                )
            );
        } else {
            handleGoToDashboard();
        }
    }

    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const onClickOpenModalUpdateTask = () => {
        setOpenModal(true)
    };

    
    return (
        <WrapMain>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={infoAlert?.open}
                onClose={() => setInfoAlert({ open: false, message: "" })}
                autoHideDuration={6000}
            >
                <Alert
                    onClose={() => setInfoAlert({ open: false, message: "" })}
                    severity="success"
                    variant="filled"
                >
                    {infoAlert?.message}
                </Alert>
            </Snackbar>
            {openModal && (
                <UpdateTaskModal
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    plannedActivities={plannedActivities}
                    messageSummary={messageSummary}
                    activesSquadData={activesSquadData}
                    setInfoAlert={setInfoAlert}
                    getDailyCloseData={getDailyCloseData}
                />
            )}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                }}
            >
                {/* Title */}
                <Box className="history_task_container_header">
                    <ButtonCircle
                        icon="/assets/icons/back.svg"
                        iconHeight={40}
                        iconWidth={40}
                        onClick={() => handleGoToDashboard()}
                    />
                    <Box className="history_task_container_title">
                        Cierre Día
                    </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                    <Grid container spacing={2} sx={{ padding: "10px 50px" }}>
                        <Grid size={12}>
                            <Box>
                                {/* Tabs */}
                                <Box
                                    sx={{
                                        borderBottom: 1,
                                        borderColor: "divider",
                                    }}
                                >
                                    <Tabs value={value} onChange={handleChange}>
                                        <Tab
                                            label="Resumen"
                                            {...a11yProps(0)}
                                        />
                                        <Tab
                                            label="Fotos del día"
                                            {...a11yProps(1)}
                                        />
                                        {/* <Tab
                                            label="Requerimientos"
                                            {...a11yProps(2)}
                                        /> */}
                                    </Tabs>
                                </Box>

                                <SummaryComponent
                                    value={value}
                                    messageSummary={messageSummary}
                                    start={mainState.reportFilters?.startDate}
                                    end={mainState.reportFilters?.endDate}
                                    onClickUpdateTask={onClickOpenModalUpdateTask}
                                    activesSquadData={activesSquadData}
                                    setActivesSquadData={setActivesSquadData}
                                    locations={locationWithoutProduction}
                                    setlocationWithoutProduction={setlocationWithoutProduction}
                                />
                                <FilesViewer
                                    value={value}
                                    start={mainState.reportFilters?.startDate}
                                    end={mainState.reportFilters?.endDate}
                                    filesForDataRange={filesForDataRange}
                                />
                                {/* <PlannedActivitiesComponent
                                    value={value}
                                    plannedActivities={plannedActivities}
                                    handleChangeTab={handleChange}
                                    handleChangeRequirementFilter={
                                        handleChangeRequirementFilter
                                    }
                                />
                                <RequirementComponent
                                    value={value}
                                    messageSummary={messageSummary}
                                    plannedActivities={plannedActivities}
                                    requirementFilter={requirementFilter}
                                    handleChangeRequirement={
                                        handleChangeRequirementFilter
                                    }
                                /> */}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </WrapMain>
    );
};

export default index;
